import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import {
  CreatePostcodeYearRuleRequest,
  UpdatePostcodeYearRuleRequest,
} from "../models/PostcodeGroup";

export default function usePostcodeYearRules() {
  const { post, patch, del } = useApiHelper();
  const queryClient = useQueryClient();

  // Year rules come down inside the group payload, so every mutation refreshes that same query -
  // both the group list and the single-group view are keyed on "postcodeGroups".
  const invalidate = () => queryClient.invalidateQueries(["postcodeGroups"]);

  const create = useMutation(
    (yearRule: CreatePostcodeYearRuleRequest) => post("/postcodePrice/yearRule", yearRule),
    { onSuccess: invalidate }
  );

  const update = useMutation(
    (yearRule: UpdatePostcodeYearRuleRequest) => patch("/postcodePrice/yearRule", yearRule),
    { onSuccess: invalidate }
  );

  const remove = useMutation(
    (yearRuleId: string) => del(`/postcodePrice/yearRule/${yearRuleId}`),
    { onSuccess: invalidate }
  );

  return { create, update, remove };
}
